import { useEffect, useState } from "react";
import { Newspaper, TriangleAlert, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { t, locale } from "@/i18n";

export const AlertsPanel = ({ alerts, route }) => {
  const [news, setNews] = useState(null);
  const [tab, setTab] = useState("anas");

  useEffect(() => {
    api.get("/news/ansa").then((r) => setNews(r.data)).catch(() => setNews({ items: [], available: false }));
  }, []);

  const onRoute = new Set((route?.on_route || []).map((a) => a.id));
  const avoided = new Set((route?.avoided || []).map((a) => a.id));

  return (
    <div className="nv-card p-4" data-testid="alerts-panel">
      <div className="grid grid-cols-2 gap-2">
        {[["anas", "Avvisi ANAS", TriangleAlert], ["ansa", "Notizie ANSA", Newspaper]].map(([k, l, I]) => (
          <button key={k} data-testid={`alerts-tab-${k}`} onClick={() => setTab(k)}
            className={`nv-press min-h-[56px] rounded-xl font-display text-lg font-bold uppercase flex items-center justify-center gap-2 border-2 ${tab === k ? "bg-[#4accff] text-[#0b0f17] border-[#4accff]" : "border-[#243047] text-slate-300"}`}>
            <I className="h-5 w-5" /> {t(l)}
          </button>
        ))}
      </div>
      <div className="mt-3 space-y-2 max-h-[34vh] overflow-y-auto pr-1">
        {tab === "anas" && alerts.map((a) => (
          <div key={a.id} className="rounded-xl p-3 bg-white/5 border-l-4" style={{ borderColor: onRoute.has(a.id) ? "#ef0298" : avoided.has(a.id) ? "#10b981" : "#475569" }} data-testid={`anas-alert-${a.id}`}>
            <p className="text-xs uppercase tracking-wider text-slate-400">{t(a.road)} · {t(a.type)}{a.demo ? ` · ${t("dimostrativo")}` : ""}{a.min_weight_t ? ` · ${t("mezzi oltre {w} t", { w: a.min_weight_t })}` : ""}</p>
            <p className="font-semibold">{t(a.title)}</p>
            <p className="text-sm text-slate-400">{t(a.description)}</p>
            {avoided.has(a.id) && <p className="text-sm text-[#10b981] font-bold mt-1">{t("Evitato dal ricalcolo")}</p>}
            {onRoute.has(a.id) && <p className="text-sm text-[#ef0298] font-bold mt-1">{t("Sul tuo percorso")}</p>}
          </div>
        ))}
        {tab === "ansa" && !news && <p className="text-slate-400">{t("Caricamento notizie…")}</p>}
        {tab === "ansa" && news?.available && !locale().startsWith("it") && <p className="text-xs text-slate-500" data-testid="ansa-lang-note">{t("Notizie in lingua italiana")}</p>}
        {tab === "ansa" && news && !news.available && <p className="text-slate-400" data-testid="ansa-unavailable">{t("Notizie ANSA non disponibili al momento.")}</p>}
        {tab === "ansa" && news?.items.map((n, i) => (
          <a key={i} href={n.link} target="_blank" rel="noreferrer" className="block rounded-xl p-3 bg-white/5 border-l-4" style={{ borderColor: n.road_related ? "#4accff" : "#334155" }} data-testid={`ansa-item-${i}`}>
            {n.road_related && <p className="text-xs uppercase tracking-wider text-[#4accff] font-bold">{t("Viabilità")}</p>}
            <p className="font-semibold flex gap-2">{n.title} <ExternalLink className="h-4 w-4 shrink-0 text-slate-500" /></p>
            <p className="text-xs text-slate-500">{n.published && !isNaN(new Date(n.published)) ? new Date(n.published).toLocaleString(locale(), { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : n.published}</p>
          </a>
        ))}
      </div>
    </div>
  );
};
